import { AudioPlayer } from 'shared/components/AudioPlayer';
import type { PublishedEpisode } from 'shared/data/episodes';

interface AudioPlayerSectionProps {
  episode: PublishedEpisode;
}

export function AudioPlayerSection({ episode }: AudioPlayerSectionProps) {
  return (
    <section className="max-w-5xl mx-auto px-6 lg:px-12 mt-12 md:mt-24">
      <AudioPlayer mode="inline" episode={episode} />
    </section>
  );
}
